import { LazyIcon } from "@op/icons";
import type { TabCardItemProps } from "@op/puck-types";
import { Print_Dc_Card_IconText } from "@op/sf-op";

const TabCardItem = ({ title, children, icon }: TabCardItemProps) => {
  return (
    <Print_Dc_Card_IconText
      style={{
        breakInside: "avoid-page",
      }}
      headline={title}
      hasHeadline={!!title}
      text={children}
      icon={icon && <LazyIcon icon={icon} />}
    />
  );
};

export default TabCardItem;
